import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import first from 'lodash/first';
import last from 'lodash/last';
import { useReactiveVar } from '@apollo/client';

import { Icon } from 'components';
import { injectStyles } from 'utils';
import { getWhitelabel } from '@/graphql/LocalState/whitelabel';
import { ProjectsPageSubNavItem } from './ProjectsPageSubNavItem';
import { useProjects } from '@/graphql/Project/hooks';
import styles from './ProjectsPageSubNav.module.scss';

export const ProjectsPageSubNav = ({
	items,
	verticalFoldersScroll,
	action,
	foldersLoading,
	loading,
}) => {
	const whitelabel = useReactiveVar(getWhitelabel);
	const wrapperClasses = cx(styles.wrapper, {
		[styles.verticalFoldersScroll]: verticalFoldersScroll,
	});

	const [
		projects,
		,
		{ loading: projectsLoading, error },
	] = useProjects({
		project_group_id: -1,
	});	
	
	if(foldersLoading || projectsLoading) {
		return (
			<ul className={wrapperClasses}>
				{whitelabel ? setWhiteLabelCss(whitelabel) : null}
				<ProjectsPageSubNavItem
					key={`sub_nav_item_${items[0].id || Math.random()}`}
					item={items[0]}
					// isWhitelabel={isWhitelabel}
					whitelabel={whitelabel}
					verticalFoldersScroll={verticalFoldersScroll}
					action={action}
				/>
				<div
					style={{
						height: 50,
						display: 'flex',
						alignItems: 'center',
						marginLeft: 20,
					}}
				>
					<Icon loading />
				</div>
			</ul>
		)
	}
	
	return (
		<ul className={wrapperClasses}>
			{whitelabel ? setWhiteLabelCss(whitelabel) : null}
			{
				items.slice(0, items.length - 1).map((item) => (
					<ProjectsPageSubNavItem
						key={`sub_nav_item_${item.id || Math.random()}`}
						item={item}
						// isWhitelabel={isWhitelabel}
						whitelabel={whitelabel}
						verticalFoldersScroll={verticalFoldersScroll}
						action={action}
					/>
				))
			}
			{
				projects?.data.length ?
				<ProjectsPageSubNavItem
					key={`sub_nav_item_${last(items).id || Math.random()}`}
					item={last(items)}
					// isWhitelabel={isWhitelabel}
					whitelabel={whitelabel}
					verticalFoldersScroll={verticalFoldersScroll}
					action={action}
				/>: null
			}
		</ul>
	);
};

const setWhiteLabelCss = ({ whitelabel }) => {
	if (!whitelabel) return null;

	const _css = `
    .sn_whitelabel.sn_active button {
        color: ${whitelabel.primary_color};
    }
    .sn_whitelabel button:hover  {
        color: ${whitelabel.primary_color};
        // filter : brightness(.9);
        opacity: 0.9;
    }
    
`;

	injectStyles('whitelabel_sn', _css);
};

ProjectsPageSubNav.propTypes = {
	items: PropTypes.array.isRequired,
	verticalFoldersScroll: PropTypes.bool,
	action: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
};
